
export const UiCardSk = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6 flex items-center justify-between">
            <div className="flex-1">
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mb-3"></div>
                <div className="h-8 w-32 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="h-3 w-20 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="w-16 h-16 bg-blue-100 rounded-full animate-pulse"></div>
        </div>
    )
}

export const BarChartSk = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="h-6 w-32 bg-gray-200 rounded animate-pulse mb-6"></div>
            <div className="flex items-end justify-between h-64 gap-4">
                <div className="w-full h-3/4 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-1/4 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-1/3 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-1/6 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-full bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-1/3 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-full h-1/6 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="flex justify-between mt-4">
                {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                    <div key={i} className="h-3 w-12 bg-gray-200 rounded animate-pulse"></div>
                ))}
            </div>
        </div>
    )
}

export const LineChartSk = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="h-6 w-40 bg-gray-200 rounded animate-pulse mb-6"></div>
            <div className="h-64 bg-gray-200 rounded-lg animate-pulse"></div>
            <div className="flex justify-between mt-4">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="h-3 w-16 bg-gray-200 rounded animate-pulse"></div>
                ))}
            </div>
        </div>
    )
}

export const Skeleton = ({ className = '', variant = 'rectangular', animation = 'pulse' }) => {
    const baseClasses = 'bg-gray-200';
    const animationClasses = animation === 'pulse' ? 'animate-pulse' : animation === 'wave' ? 'animate-shimmer' : '';
    const variantClasses = variant === 'circular' ? 'rounded-full' : variant === 'rounded' ? 'rounded-lg' : 'rounded';

    return <div className={`${baseClasses} ${animationClasses} ${variantClasses} ${className}`} />;
};

export const SkeletonButton = ({ width = 'w-24', height = 'h-10', className = '' }) => {
    return <Skeleton className={`${width} ${height} rounded-md ${className}`} />;
};

export const SkeletonCard = ({ children, className = '' }: { children: React.ReactNode, className?: string }) => {
    return (
        <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
            {children}
        </div>
    );
};

export const SkeletonText = ({ width = 'w-full', height = 'h-4', className = '' }) => {
    return <Skeleton className={`${width} ${height} ${className}`} />;
};


const DashboardSkeleton = () => {
    return (
        <div className="min-h-screen bg-transparent p-6">
            {/* Header */}
            <div className="mb-8">
                <div className="h-8 w-48 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="h-4 w-72 bg-gray-200 rounded animate-pulse"></div>
            </div>

            {/* Stats Grid - Top Row */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                {[...Array(6)].map((_, i) => <UiCardSk key={i} />)}
            </div>
            {/* Charts Section */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <BarChartSk />
                {/* Revenue Growth Chart */}
                <LineChartSk />
            </div>
        </div>
    );
};

export default DashboardSkeleton;